import gql from "graphql-tag"

import { useGraphqlMutation } from "#React/hooks/useGraphqlMutation"

const chartSettingsMutation = gql`
  mutation updateChartSettings(
    $chartShowHorizontalLines: Boolean
    $chartShowVerticalLines: Boolean
    $chartLineThickness: Float
    $chartColorPalette: String
    $chartShowMarkers: Boolean
  ) {
    updateViewer(
      chartShowHorizontalLines: $chartShowHorizontalLines
      chartShowVerticalLines: $chartShowVerticalLines
      chartLineThickness: $chartLineThickness
      chartColorPalette: $chartColorPalette
      chartShowMarkers: $chartShowMarkers
    ) {
      id
      chartShowHorizontalLines
      chartShowVerticalLines
      chartLineThickness
      chartColorPalette
      chartShowMarkers
      __typename
    }
  }
`

export function useChartSettingsMutation() {
  const { mutate: updateChartSettings } = useGraphqlMutation({ document: chartSettingsMutation })

  const persistHorizontalSupportLines = React.useCallback(
    (isEnabled) => {
      updateChartSettings({
        chartShowHorizontalLines: isEnabled,
      })
    },
    [updateChartSettings],
  )

  const persistVerticalSupportLines = React.useCallback(
    (isEnabled) => {
      updateChartSettings({
        chartShowVerticalLines: isEnabled,
      })
    },
    [updateChartSettings],
  )

  const persistLineThickness = React.useCallback(
    (lineThickness) => {
      updateChartSettings({
        chartLineThickness: lineThickness,
      })
    },
    [updateChartSettings],
  )

  const persistColorPalette = React.useCallback(
    (colorPalette) => {
      updateChartSettings({
        chartColorPalette: colorPalette,
      })
    },
    [updateChartSettings],
  )

  const persistMarkers = React.useCallback(
    (showMarkers) => {
      updateChartSettings({
        chartShowMarkers: showMarkers,
      })
    },
    [updateChartSettings],
  )

  return {
    persistHorizontalSupportLines,
    persistVerticalSupportLines,
    persistLineThickness,
    persistColorPalette,
    persistMarkers,
  }
}
